import React from 'react';
import { Truck, PartyPopper } from 'lucide-react';
import { useT } from '../services/i18n';
import { fmtEuro } from '../services/shippingInfo';

// Gauge towards the free-shipping threshold, filling up as items are added
const FreeShippingProgress = ({ subtotal, freeFrom, countryName }) => {
  const { t } = useT();
  if (freeFrom == null) return null;
  const reached = subtotal >= freeFrom;
  const pct = Math.min(100, Math.round((subtotal / freeFrom) * 100));
  return (
    <div data-testid="free-shipping-progress" className={`rounded-lg border p-3 ${reached ? 'bg-green-50 border-green-200' : 'bg-orange-50/60 border-orange-200'}`}>
      <p className={`text-xs font-medium flex items-center gap-1.5 ${reached ? 'text-green-700' : 'text-orange-700'}`} data-testid="free-shipping-progress-text">
        {reached ? <PartyPopper size={14} /> : <Truck size={14} />}
        {reached ? t('cart.freeShippingReached') : t('cart.freeShippingLeft', { amount: fmtEuro(freeFrom - subtotal).replace(' €', '') })}
        {countryName && <span className="text-gray-400 font-normal">· {countryName}</span>}
      </p>
      <div className="mt-2 h-2 w-full bg-white rounded-full overflow-hidden border border-black/5" role="progressbar" aria-valuenow={pct} aria-valuemin={0} aria-valuemax={100}>
        <div data-testid="free-shipping-progress-bar" className={`h-full rounded-full transition-[width] duration-700 ease-out ${reached ? 'bg-green-500' : 'bg-orange-500'}`} style={{ width: `${pct}%` }} />
      </div>
      <div className="flex justify-between text-[10px] text-gray-400 mt-1"><span>{fmtEuro(Math.min(subtotal, freeFrom))}</span><span>{fmtEuro(freeFrom)}</span></div>
    </div>
  );
};

export default FreeShippingProgress;
